import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  AdOverlayStyled,
  Content,
  CloseButton,
} from './styles/AdOverlayStyled';

const TOP_OVERLAY_POS = 90;

class AdOverlay extends Component {
  constructor(props) {
    super(props);
    this.initialDims = {
      width: 0,
      height: 0,
    };
    this.tryUpdateInitialDims(props.playerDims);
    this.needUpdateDims = false;
    this.originalOverlayDims = null;
    this.rootElement = null;
    this.overlayContainer = null;
    this.overlayPaused = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.playerPaused !== nextProps.playerPaused &&
      !nextProps.playerPaused &&
      this.overlayPaused
    ) {
      this.overlayPaused = false;
      this.props.resume();
    }
  }

  shouldComponentUpdate(nextProps) {
    this.needUpdateDims = !_.isEqual(
      this.props.playerDims,
      nextProps.playerDims
    );
    return (
      nextProps.overlayInfo.playing !== this.props.overlayInfo.playing ||
      this.needUpdateDims ||
      nextProps.skinIsVisible !== this.props.skinIsVisible ||
      nextProps.position !== this.props.position
    );
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const { playerDims: nextDims, overlayInfo, adContainer, type } = nextProps;
    const { playerDims: prevDims, overlayInfo: prevInfo } = this.props;
    if (!_.isEqual(nextDims, prevDims)) {
      this.tryUpdateInitialDims(nextDims);
    }
    if (overlayInfo.playing && overlayInfo.playing !== prevInfo.playing) {
      for (let i = 0, l = adContainer.children.length; i < l; ++i) {
        if (adContainer.children[i].id === 'ad:overlay') {
          this.overlayContainer = adContainer.children[i];
          break;
        }
      }
      if (this.overlayContainer) {
        if (
          this.overlayContainer.firstElementChild instanceof HTMLIFrameElement
        ) {
          window.addEventListener('message', this.onWindowMessage);
        }
        this.rootElement.insertBefore(
          this.overlayContainer,
          this.rootElement.firstChild
        ); // firstChild is closeButton
        if (!this.originalOverlayDims) {
          this.originalOverlayDims = {
            width: this.overlayContainer.offsetWidth,
            height: this.overlayContainer.offsetHeight,
          };
        }

        let overlayIsBigger = false;
        if (this.originalOverlayDims.width > nextDims.width) {
          this.needUpdateDims = true;
          overlayIsBigger = true;
          const oldWidth = this.originalOverlayDims.width;
          this.originalOverlayDims.width = nextDims.width;
          this.originalOverlayDims.height = Math.min(
            this.originalOverlayDims.height *
              (oldWidth / this.originalOverlayDims.width) -
              TOP_OVERLAY_POS,
            nextDims.height - TOP_OVERLAY_POS
          );
        }

        if (this.needUpdateDims) {
          this.needUpdateDims = false;
          if (overlayInfo.scalable || overlayIsBigger) {
            this.overlayContainer.style.width = `${
              this.originalOverlayDims.width *
              (nextDims.width / this.initialDims.width)
            }px`;
            this.overlayContainer.style.height = `${
              this.originalOverlayDims.height *
              (nextDims.height / this.initialDims.height)
            }px`;
          }
        }
      }
    } else if (type === '' && this.originalOverlayDims) {
      this.originalOverlayDims = null;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onWindowMessage);
    this.overlayContainer = null;
  }

  onWindowMessage = (event) => {
    if (event && event.data === 'click') {
      this.processClickThrough();
    }
  };

  onClose = () => this.props.close(true);

  tryUpdateInitialDims = (dims) => {
    if (dims) {
      if (this.initialDims.width === 0 || this.initialDims.height === 0) {
        this.initialDims.width = dims.width;
        this.initialDims.height = dims.height;
      }
    }
  };

  processClickThrough = () => {
    if (this.props.overlayInfo.isClickable) {
      if (!this.props.playerPaused) {
        this.props.playerPause();
      }
      this.props.click(this.props.overlayInfo.clickThroughLink, true);
      this.overlayPaused = true;
    }
  };

  assignRootRef = (ref) => {
    this.rootElement = ref;
  };

  render() {
    const {
      overlayInfo,
      position,
      skinIsVisible,
      isMobile,
      isNewSkin,
      isBigSkin,
    } = this.props;
    const { skipTime2, horizontalPosition } = overlayInfo;
    let showClose;

    if (skipTime2 !== undefined) {
      showClose = position > parseInt(skipTime2, 10);
    }

    return (
      <AdOverlayStyled
        position={horizontalPosition}
        hiddenSkin={!skinIsVisible}
        isNewSkin={isNewSkin}
        isBigSkin={isBigSkin}
        isMobile={isMobile}
      >
        <Content ref={this.assignRootRef} onClick={this.processClickThrough} />
        {showClose && (
          <CloseButton
            icon="close"
            iconSize={isMobile ? 20 : 24}
            onClick={this.onClose}
          />
        )}
      </AdOverlayStyled>
    );
  }
}

AdOverlay.propTypes = {
  overlayInfo: PropTypes.shape({
    horizontalPosition: PropTypes.string,
    skipTime2: PropTypes.number,
    scalable: PropTypes.bool,
    playing: PropTypes.bool,
    clickThroughLink: PropTypes.string,
    isClickable: PropTypes.bool,
  }),
  close: PropTypes.func.isRequired,
  resume: PropTypes.func.isRequired,
  playerPause: PropTypes.func.isRequired,
  playerPaused: PropTypes.bool.isRequired,
  click: PropTypes.func.isRequired,
  position: PropTypes.number,
  playerDims: PropTypes.object,
  skinIsVisible: PropTypes.bool,
  adContainer: PropTypes.object,
  isNewSkin: PropTypes.bool.isRequired,
  isBigSkin: PropTypes.bool.isRequired,
};

AdOverlay.defaultProps = {
  overlayInfo: {},
  position: 0,
  playerDims: {},
  skinIsVisible: true,
  adContainer: null,
};

export default AdOverlay;
